<template>
  <div>
    <v-layout column align-center>
      <h2>Running {{os.name}} with .net {{os.dotNet}}</h2>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md6 lg6>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{getString('Configurazione sito')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-side-icon @click="hidden = !hidden">
              <v-icon class="q-text-whitesmoke" :class="{'module-closed' : !hidden}">arrow_drop_down</v-icon>
            </v-toolbar-side-icon>
          </v-toolbar>
          <v-layout row wrap v-show="!hidden">
            <v-flex xs12 sm12 md12 lg12>
              <v-card>
                <v-toolbar class="elevation-0 no-cradius" height="50px">
                  <h2>{{getString('Modifica il config del sito')}}</h2>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-flex xs12 sm12 md6 lg6>
                         <v-switch v-model="config.maintenance" :label="getString('Manutenzione')"></v-switch>
                      </v-flex>
                    <h4>Web</h4>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Durata cookie normale')}}</label>
                        <v-text-field
                          v-model="config.site.cookieExpire"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Durata cookie normale')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Durata cookie ricordami')}}</label>
                        <v-text-field
                          v-model="config.site.cookieRemember"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Durata cookie ricordami')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Durata cookie Samuel L. J. Fisher 4th Echelon')}}</label>
                        <v-text-field
                          v-model="config.site.cookieFake"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Durata cookie Samuel L. J. Fisher 4th Echelon')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Numero massimo prenotazioni')}}</label>
                        <v-text-field
                          v-model="config.site.maxReservations"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Numero massimo prenotazioni')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <h4>Versione free</h4>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Limite prenotazioni')}}</label>
                        <v-text-field
                          v-model="config.freeVersion.reservationsLimit"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Prenotazioni massime')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Limite giorni prenotabili')}}</label>
                        <v-text-field
                          v-model="config.freeVersion.weekDayLimit"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Limite giorni prenotabili')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Limite dipendenti')}}</label>
                        <v-text-field
                          v-model="config.freeVersion.employeesLimit"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Limite dipendenti')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <label>{{getString('Email sito')}}</label>
                    <v-text-field
                      v-model="config.site.mail"
                      style="max-width:500px"
                      :rules="emailRule"
                      solo
                      :label="getString('Email sito')"
                    ></v-text-field>
                    <!-- <v-expansion-panel>
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div>App</div>
                        </template> -->
                  
                      <!--  </v-expansion-panel-content>
                    </v-expansion-panel> -->
                    <!-- <h4>Token</h4>
                    <label>{{getString('Secret key')}}</label>
                    <v-text-field
                      v-model="config.jwt.secretKey"
                      :rules="notEmpty"
                      solo
                      :label="getString('Secret key')"
                    ></v-text-field>
                    <h4>Facebook</h4>
                    <label>{{getString('Api url')}}</label>
                    <v-text-field
                      v-model="config.facebook.url"
                      :rules="notEmpty"
                      solo
                      :label="getString('Api URL')"
                    ></v-text-field>
                    <h4>Firebase</h4>
                    <label>{{getString('App IDQuickBe')}}</label>
                    <v-text-field
                      v-model="config.firebaseNotification.applicationIDQuickBe"
                      :rules="notEmpty"
                      solo
                      :label="getString('App ID QuickBe')"
                    ></v-text-field> -->
                    <h4>App</h4>
                    <label>{{getString('Version')}}</label>
                    <v-text-field
                      v-model="config.appSettings.version"
                      :rules="notEmpty"
                      solo
                      :label="getString('Version')"
                    ></v-text-field>
                    <!-- <label>{{getString('Api secret')}}</label>
                    <v-text-field
                      v-model="config.appSettings.secret"
                      :rules="notEmpty"
                      solo
                      :label="getString('Api secret')"
                    ></v-text-field> -->
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md6 lg6>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{getString('Configurazione host')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-side-icon @click="hidden = !hidden">
              <v-icon class="q-text-whitesmoke" :class="{'module-closed' : !hidden}">arrow_drop_down</v-icon>
            </v-toolbar-side-icon>
          </v-toolbar>
          <v-layout row wrap v-show="!hidden">
            <v-flex xs12 sm12 md12 lg12>
              <v-card>
                <v-toolbar class="elevation-0 no-cradius" height="50px">
                  <h2>{{getString('Modifica l\'host del sito')}}</h2>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <h4>Database</h4>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Nome schema')}}</label>
                        <v-text-field
                          v-model="host.database.schema"
                          style="max-width:500px"
                          :rules="notEmpty"
                          solo
                          :label="getString('Nome schema')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Porta')}}</label>
                        <v-text-field
                          v-model="host.database.port"
                          style="max-width:500px"
                          :rules="numRule"
                          solo
                          :label="getString('Durata cookie ricordami')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Host')}}</label>
                        <v-text-field
                          v-model="host.database.host"
                          style="max-width:500px"
                          :rules="notEmpty"
                          solo
                          :label="getString('Host')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Prefisso tabelle')}}</label>
                        <v-text-field
                          v-model="host.database.tablePrefix"
                          style="max-width:500px"
                          solo
                          :label="getString('Prefisso tabelle')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{getString('Altre opzioni')}}</label>
                        <v-text-field
                          v-model="host.database.otherOptions"
                          :rules="notEmpty"
                          solo
                          :label="getString('Opzioni supplementari')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <h4>Host</h4>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Url base dell\'host')}}</label>
                        <v-text-field
                          v-model="host.host.hostUrl"
                          style="max-width:500px"
                          :rules="notEmpty"
                          solo
                          :label="getString('Url')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6>
                        <label>{{getString('Indirizzo generato')}}</label>
                        <v-text-field
                          v-model="host.host.generatedAddress"
                          style="max-width:500px"
                          :rules="emailRule"
                          solo
                          :label="getString('Indirizzo generato')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                  <v-tooltip left>
                    <v-flex slot="activator">
                      <label>{{getString('Attenzione, comporterà un riavvio di sessione')}}</label>
                      <br>
                      <v-btn
                        color="red lighten-0"
                        @click="sekKeyDialog = true"
                        class="q-text-whitesmoke"
                      >
                        {{getString('Salva tutto')}}
                        <v-icon color="white">warning</v-icon>
                      </v-btn>
                    </v-flex>
                    <span>
                      <h3>{{getString('Attenzione, se qui fai qualche cazzata pesante potresti dover editare manualmente i file e riavviare tutto manualmente lato cli')}}</h3>
                    </span>
                  </v-tooltip>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="sekKeyDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{getString('Inserisci chiave di sicurezza')}}</v-card-title>
        <v-card-text>{{getString('Per modifiche di alto borgo devi inserire la chiave di sicurezza?')}}</v-card-text>
        <v-card-text>
          <v-text-field v-model="skey" style="max-width:500px" solo :label="getString('s. key')"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat
            @click.native="sekKeyDialog = false"
          >{{getString('Torna alla pagina')}}</v-btn>
          <v-btn color="green darken-1" flat @click.native="setConfig">{{getString('Ok')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Utils from "../../utils.js";
import ajax from "../../ajax.js";
var ut = new Utils();
export default {
  name: "Server",
  mounted: function() {
    this.getConfig();
  },
  computed: {
    notEmpty: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    emailRule: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateEmail(v) || this.getString("Email non valida")
      ];
    },
    numRule: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v =>
          ut.ValidateNumber(v) ||
          this.getString("Numero non valido, torniamo a scuola per cortesia?")
      ];
    },
    siteValid: function() {
      return (
        ut.ValidateNumber(this.config.site.cookieExpire) &&
        ut.ValidateNumber(this.config.site.cookieRemember) &&
        ut.ValidateNumber(this.config.site.cookieFake) &&
        ut.ValidateNumber(this.config.site.maxReservations) &&
        ut.ValidateEmail(this.config.site.mail)
      );
    }
  },
  data: () => {
    return {
      h: null,
      skey: null,
      sekKeyDialog: false,
      hidden: false,
      hostValid: true,
      host: {
        database: {
          tablePrefix: "dev_",
          host: "uhauahuahuahuahauhauhuahu.soreta",
          port: "3066",
          schema: "mmmm",
          user: "lol",
          password: "carriageoverthecarriage",
          otherOptions: ""
        },
        host: {
          hostUrl: "http://localhost:1000",
          generatedAddress: "no-reply@domain.eu"
        }
      },
      os: {
        name: "",
        dotNet: ""
      },
      config: {
        site: {
          cookieExpire: "3000",
          cookieRemember: 144000,
          cookieFake: 3000,
          maxReservations: 3,
          mail: "fake@fake.eu"
        },
        freeVersion: {
          reservationsLimit: 100,
          employeesLimit: 2,
          weekDayLimit: 2
        },
        appSettings: {
          secret: "=",
          version: "0.0.0"
        },
        versionCheck: {
          quickBe: {
            android: {
              versionMin: 0,
              versionRecommended: 0
            },
            iOS: {
              versionMin: 0,
              versionRecommended: 0
            }
          },
          masko: {
            android: {
              versionMin: 0,
              versionRecommended: 0
            },
            iOS: {
              versionMin: 0,
              versionRecommended: 0
            }
          },
          iLanza: {
            android: {
              versionMin: 0,
              versionRecommended: 0
            },
            iOS: {
              versionMin: 0,
              versionRecommended: 0
            }
          },
          perrotti: {
            android: {
              versionMin: 0,
              versionRecommended: 0
            },
            iOS: {
              versionMin: 0,
              versionRecommended: 0
            }
          }
        },
        jwt: {
          secretKey: "If you read this token you are a figl e bucchin"
        },
        facebook: {
          url:
            "https://graph.facebook.com/v2.8/me?fields=id,first_name,last_name,email,picture.height(800)&access_token="
        },
        firebaseNotification: {
          applicationIDBarbero: "fake",
          applicationIDQuickBe: "fake"
        },
        maintenance : false
      }
    };
  },
  methods: {
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    getConfig: function() {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/server/get", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true
        })
        .then(function(response) {
          ajax.validateToken(response.headers, self.$store);
          self.config = response.data.data.config;
          self.host = response.data.data.host;
          self.os = response.data.data.os;
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    setConfig: function() {
      if (this.siteValid && this.hostValid) {
        let self = this;
        ajax.axios
          .put(
            ajax.baseUrl() + "/admin/server/set",
            {
              config: self.config,
              host: self.host,
              skey: self.skey
            },
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit("siteAlertSuccess", response.data.data);
            self.sekKeyDialog = false;
            self.skey = "";
          })
          .catch(function(error) {
            self.sekKeyDialog = false;
            self.skey = "";
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.data.errorMessage
            );
          });
      } else {
        this.$emit("siteAlert", this.getString("Alcuni campi non validi"));
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/backend/Server.vue